import { t } from 'i18next';
import { NewOption } from './types';
import { toast } from 'react-toastify';
import { apiCall } from 'providers';
import { IrCode } from '~/providers/types/irCodes';

export const MIN_LTI_SETPOINT_SCHEDULE = 8;
export const DEFAULT_SETPOINT_ON_DEMAND = '22';

export const defaultActionModeOptions: NewOption[] = [
  { label: t('refrigerar'), value: t('refrigerar') },
  { label: t('ventilacao'), value: t('ventilacao') },
  { label: t('eco'), value: t('eco') },
];
export const defaultActionPostModeOptions: NewOption[] = [
  { label: t('refrigerar'), value: t('refrigerar') },
  { label: t('ventilacao'), value: t('ventilacao') },
  { label: t('modoDesligar'), value: t('modoDesligar') },
  { label: t('semAcao'), value: t('semAcao') },
];

export const defaultActionModes = {
  [t('eco')]: 'ECO',
  [t('refrigerar')]: 'Enabled',
  [t('ventilacao')]: 'Ventilation',
  [t('modoDesligar')]: 'Disabled',
  [t('semAcao')]: 'NoAction',
};

export const getOptionByKey = (action: string, options: NewOption[]): NewOption => options.find((item) => item.value === action) as NewOption;

export const getCoolSetpointDefaultCommandValue = (
  devId: string,
  irCommands: {
    IR_ID: string;
    CMD_NAME: string;
    CMD_TYPE: string | null;
    TEMPER: number;
  }[],
): number | undefined => {
  if (!irCommands?.length) {
    toast.info(t('avisoIrSetpointNaoEncontradoModoRefrigerar'));
    return undefined;
  }

  let defaultCommand = irCommands.find(
    (command) => command.TEMPER === 22,
  );

  if (!defaultCommand) {
    defaultCommand = irCommands.reduce(
      (prev, current) => (current.TEMPER < prev.TEMPER ? current : prev),
      irCommands[0],
    );
  }

  if (!defaultCommand) {
    toast.info(t('avisoIrSetpointNaoEncontradoModoRefrigerar'));
    return undefined;
  }

  if (!defaultCommand.CMD_TYPE && devId) {
    apiCall('/define-ircode-action', {
      devId,
      IR_ID: defaultCommand.IR_ID,
      CMD_TYPE: 'AC_COOL',
      CMD_DESC: '',
      TEMPER: defaultCommand.TEMPER,
    })
      .then(() => {
        if (defaultCommand) {
          defaultCommand.CMD_TYPE = 'AC_COOL';
        }
      })
      .catch((err) => {
        console.error(err);
        toast.error(t('erroDefinirIRAcCool'));
      });
  }

  return defaultCommand.TEMPER;
};

export const getTemperatureIrId = (irCommands: IrCode[], irIdCool: string | null): number | null => {
  if (!irIdCool) return null;
  if (!irCommands || irCommands.length === 0) return null;

  const command = irCommands.find((cmd) => cmd.IR_ID === irIdCool);
  return command ? command.TEMPER : null;
};

export const getDefaultAcCoolTemperature = (irCommands: IrCode[]): number | null => {
  if (!irCommands || irCommands.length === 0) return null;

  const acCoolCommands = irCommands.filter((command) => command.CMD_TYPE === 'AC_COOL');
  if (acCoolCommands.length === 0) return null;

  const defaultCommand = acCoolCommands.find((command) => command.TEMPER === 22)
    ?? acCoolCommands.reduce((prev, current) => (current.TEMPER < prev.TEMPER ? current : prev));

  return defaultCommand.TEMPER;
};
